import { render, staticRenderFns } from "./EmbedWebsite.vue?vue&type=template&id=14dd659f&scoped=true&"
import script from "./EmbedWebsite.vue?vue&type=script&lang=js&"
export * from "./EmbedWebsite.vue?vue&type=script&lang=js&"
import style0 from "./EmbedWebsite.vue?vue&type=style&index=0&id=14dd659f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd659f",
  null
  
)

export default component.exports